var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutomateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_59301_2189",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_59301_2189)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_59301_2189)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1436 11.1436C8.92014 12.367 8.30841 13.8581 8.30841 15.6168C8.30841 13.8581 7.69669 12.367 6.47324 11.1436C5.24979 9.92014 3.75871 9.30841 2 9.30841C3.75871 9.30841 5.24979 8.69669 6.47324 7.47324C7.69669 6.24979 8.30841 4.75871 8.30841 3C8.30841 4.75871 8.92014 6.24979 10.1436 7.47324C11.367 8.69669 12.8581 9.30841 14.6168 9.30841C12.8581 9.30841 11.367 9.92014 10.1436 11.1436ZM19.2048 15.0025C18.3891 15.8454 17.9813 16.8726 17.9813 18.0841C17.9813 16.8726 17.5735 15.8454 16.7579 15.0025C15.9422 14.1597 14.9482 13.7383 13.7757 13.7383C14.9482 13.7383 15.9422 13.3169 16.7579 12.4741C17.5735 11.6313 17.9813 10.6041 17.9813 9.39252C17.9813 10.6041 18.3891 11.6313 19.2048 12.4741C20.0204 13.3169 21.0144 13.7383 22.1869 13.7383C21.0144 13.7383 20.0204 14.1597 19.2048 15.0025ZM10.9159 21C10.9159 20.2496 11.1606 19.6134 11.65 19.0914C12.1393 18.5694 12.7358 18.3084 13.4393 18.3084C12.7358 18.3084 12.1393 18.0474 11.65 17.5254C11.1606 17.0034 10.9159 16.3672 10.9159 15.6168C10.9159 16.3672 10.6712 17.0034 10.1818 17.5254C9.69244 18.0474 9.09601 18.3084 8.39252 18.3084C9.09601 18.3084 9.69244 18.5694 10.1818 19.0914C10.6712 19.6134 10.9159 20.2496 10.9159 21ZM11.5888 13.7663C11.9604 13.7663 12.2617 13.4651 12.2617 13.0934C12.2617 12.7218 11.9604 12.4205 11.5888 12.4205C11.2172 12.4205 10.9159 12.7218 10.9159 13.0934C10.9159 13.4651 11.2172 13.7663 11.5888 13.7663ZM5.53271 12.4206C5.53271 12.7922 5.23145 13.0935 4.85982 13.0935C4.48819 13.0935 4.18692 12.7922 4.18692 12.4206C4.18692 12.0489 4.48819 11.7477 4.85982 11.7477C5.23145 11.7477 5.53271 12.0489 5.53271 12.4206ZM11.5888 6.86917C11.9604 6.86917 12.2617 6.5679 12.2617 6.19627C12.2617 5.82464 11.9604 5.52338 11.5888 5.52338C11.2172 5.52338 10.9159 5.82464 10.9159 6.19627C10.9159 6.5679 11.2172 6.86917 11.5888 6.86917Z",
    fill: "#1C1B1F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_59301_2189",
    x: 2,
    y: 3,
    width: 20.1869,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_59301_2189"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomateIcon);
export default __webpack_public_path__ + "static/media/automateIcon.532751d4364717e92e3d68806e3b7e34.svg";
export { ForwardRef as ReactComponent };